export default __webpack_public_path__ + "static/media/hisopado.66e2df1c.svg";